@if (configurationRouteDto) {
  <app-configuration-route-details-form
    [origRoute]="configurationRoute"
    [(name)]="configurationRouteDto.name"
    [(notes)]="configurationRouteDto.notes"
    [nameValidator]="nameValidator"
    (validityChange)="isNameValid = $event"
    [canEditRoute]="canEditRoute"
  ></app-configuration-route-details-form>
  <app-response-type-form
    [(responseType)]="configurationRouteDto.response_type"
    [(callbackUrl)]="configurationRouteDto.callback_url"
    [hasAutoAnalysis]="hasAutoAnalysis"
    [hasMachineTranslation]="!!configurationRouteDto.translation_target_language_id"
    (validityChange)="isCallbackValid = $event"
    [canEditRoute]="canEditRoute"
  ></app-response-type-form>
}
@if (hasChanges) {
  <app-lex-xi-action-button-bar
    [cancelDisabled]="isSaving"
    [saveDisabled]="!isNameValid || !isCallbackValid || isSaving"
    (cancelClicked)="cancelEdit()"
    (saveClicked)="saveEdit()"
  ></app-lex-xi-action-button-bar>
}
